import React from 'react';
import SkillsManager from './SkillsManager';

const PersonalSkillsPanel: React.FC = () => {
  return <SkillsManager />;
};

export default PersonalSkillsPanel;
